import React from "react";
import SSection from "./secondSections/SSection";

export default function Second() {
  return (
    <section className="lg:my-20 my-12">
      <section className="sm:w-4/5 w-11/12 mx-auto flex flex-col items-center">
        <h1 className="font-bold lg:text-6xl sm:text-5xl text-4xl text-themeBlue text-center">
          Shipping straight to your door
        </h1>
        <p className="font-normal sm:text-base text-sm text-center text-black text-opacity-60 xl:w-4/5 mt-6">
          Shipping internationally doesn’t have to be difficult, if you have the right partners. But getting the right suppliers can be daunting and complying to the relevant regulations is vital in ensuring your shipment passes through customs smoothly. You don’t need to have knowledge of any of these as Pacifrica Express can assist you in all of the below as we have gained valuable experience in these service offerings.
        </p>
        <section className="grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 gap-x-12 gap-y-12 mt-10">
          <SSection
            img="images/home/sec2-logo1.png"
            title="Easy Tracking"
            text=""
          />
          <SSection
            img="images/home/sec2-logo1 (2).png"
            title="Faster Delivery"
            text=""
          />
          <SSection
            img="images/home/_x31__1_.png"
            title="Instant Updates"
            text=""
          />
          <SSection
            img="images/home/Group.png"
            title="Security Covers"
            text=""
          />
          <SSection
            img="images/home/Group (1).png"
            title="Economical Shipping"
            text=""
          />
          <SSection
            img="images/home/Group (2).png"
            title="Big or Small"
            text=""
          />
          <SSection
            img="images/home/Group (3).png"
            title="Convenient"
            text=""
          />
          <SSection
            img="images/home/icon-park-outline_reload.png"
            title="Reliable service"
            text=""
          />
        </section>
      </section>
    </section>
  );
}
